export enum Fahrzeugseite {
  BEIFAHRER = 0,
  FAHRER = 1,
  FRONT = 2,
  HECK = 3,
}
